import styled, { css } from 'styled-components';
import { PlataformaProps } from '.';

export const Container = styled.div<PlataformaProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  width: fit-content;

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1; /* Number of lines to show */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => {
    return css`
      position: relative;
      border-radius: ${theme.spacing[3]}px;
      width: 84px;
      height: 84px;
      overflow: hidden;
    `;
  }}
`;
